module.exports = __webpack_public_path__ + "static/n8nWH-8d83796c4e1b6d878c3ff048d5577b67.png";